import { configuration } from '@/config';
import { keycloak } from '@/Routing/keycloak';

export const prepareHeaders = async (headers: Headers): Promise<Headers> => {
  try {
    await keycloak.updateToken(60);
  } catch (e) {
    console.debug(e);
    await keycloak
      .logout({
        redirectUri: configuration.logoutUrl,
      })
      .catch(console.debug);
  }

  if (keycloak.token) {
    headers.append('authorization', `Bearer ${keycloak.token}`);
  }

  return headers;
};
